import AppChoice from "@toothfairy/shared-ui/AppChoice";
import AppDropDown from "@toothfairy/shared-ui/AppDropDown";
import AppStateManager from "@toothfairy/shared-ui/AppStateManager";
import AppTextInput from "@toothfairy/shared-ui/AppTextInput";
import AppTheme from "@toothfairy/shared-ui/AppTheme";
import AppToast from "@toothfairy/shared-ui/AppToast";
import { AppText } from "@toothfairy/shared-ui";
import React, { useMemo, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { View } from "react-native";
import ToothFairyButton from "../../../Components/ToothFairyComponents/ToothFairyButton";
import AppWeightDistribution from "@toothfairy/shared-ui/AppWeightDistribution";
import Constants from "../../../Constants";
import useWorkspaces from "../../../Hooks/useWorkspaces";
import { isLargeScreen } from "../../MainViewContainer";
import { _baseModels } from "../../Settings/Components/QA/SubComponents/QaSettingsAIView";
import ToothFairySlider from "../../../Components/ToothFairyComponents/ToothFairySlider";

const MetaSelection = ({
  selectedTab,
  setIsBatchInitiationModalOpen,
  batchConfig,
  setBatchConfig,
  topics,
  handleBatchInitiation,
}) => {
  const { currentTheme } = AppTheme.useTheme();
  const AppToasty = AppToast.useToast();
  const { t } = useTranslation();

  const { state } = AppStateManager.useAppStateManager();
  const [finetunedModels, setFinetunedModels] = useState([]);
  const { generateAdaptedTopics, getActiveWorkspace, getFinetunedModels } =
    useWorkspaces();
  useEffect(() => {
    if (getActiveWorkspace()?.subscriptionType == "enterprise")
      setFinetunedModels(getFinetunedModels());
  }, [getActiveWorkspace()?.subscriptionType]);
  const handleWeightsChange = (weights) => {
    setBatchConfig({
      ...batchConfig,
      weights,
    });
    // Do something with the updated weights
  };

  const _reviewModels = [
    {
      name: "TF Sorcerer",
      id: "sorcerer",
      plannerAvailable: true,
    },
    {
      name: "TF Sorcerer 1.5 Thinking",
      id: "sorcerer_15",
      plannerAvailable: true,
    },
    {
      name: "TF Mystica",
      id: "mystica",
      plannerAvailable: true,
    },
    {
      name: "TF Mystica 1.5 Thinking",
      id: "mystica_15",
      plannerAvailable: true,
    },
    {
      name: "DeepSeek V3",
      id: "deepseek-ai/DeepSeek-V3",
      plannerAvailable: true,
    },
    {
      name: "Llama 3.1 8b",
      id: "meta-llama/Meta-Llama-3.1-8B-Instruct-Turbo",
      plannerAvailable: false,
    },
    {
      name: "Llama 3.1 70B",
      id: "meta-llama/Meta-Llama-3.1-70B-Instruct-Turbo",
      plannerAvailable: false,
    },
    {
      name: "Llama 3.1 Nemotron 70B",
      id: "nvidia/Llama-3.1-Nemotron-70B-Instruct-HF",
      plannerAvailable: true,
    },
    {
      name: "Llama 3.3 70b",
      id: "meta-llama/Llama-3.3-70B-Instruct-Turbo",
      plannerAvailable: true,
    },
    {
      name: "Llama 3.1 405b",
      id: "meta-llama/Meta-Llama-3.1-405B-Instruct-Turbo",
      plannerAvailable: false,
    },
    {
      name: "Qwen 2.5 72b",
      id: "Qwen/Qwen2.5-72B-Instruct-Turbo",
      plannerAvailable: false,
    },
    ...finetunedModels,
  ];

  const _inputFields = useMemo(() => {
    return (
      <>
        {(selectedTab?.routeId === "bm" || selectedTab?.routeId === "abm") && (
          <AppDropDown
            withEmptyItem
            isElevated={false}
            dropDownStyle={{
              borderColor: currentTheme?.theme?.border_color,
              maxWidth: !isLargeScreen() && 250,
            }}
            wrapperContainer={{
              marginBottom: 20,
            }}
            items={[
              {
                type: "noSelection",
                label: "Select an agent",
              },
              ...state?.agents?.filter((u) => {
                if (selectedTab?.routeId === "bm") {
                  return (
                    u?.agentType !== "planner" && u?.agentType !== "computer"
                  );
                } else if (selectedTab?.routeId === "abm") {
                  return u?.agentType === "planner";
                } else {
                  return true;
                }
              }),
            ]}
            propertyLabel="label"
            propertyValue="id"
            onValueChange={(value) => {
              console.log("value", value);
              setBatchConfig({
                ...batchConfig,
                agentId: value,
              });
            }}
          />
        )}

        <AppTextInput
          placeholder="batchNamePlaceholder"
          style={{
            marginTop: 2,
          }}
          wrapperInputStyle={{
            maxWidth: 470,
            marginBottom: 20,
          }}
          textContainer={{
            margin: 0,
          }}
          type="text"
          value={batchConfig?.name}
          onChangeText={(text) => {
            setBatchConfig({ ...batchConfig, name: text });
          }}
        />
        <AppTextInput
          multiline={true}
          numberOfLines={4}
          placeholder="batchDescrPlaceholder"
          style={{
            marginTop: 2,
          }}
          wrapperInputStyle={{
            maxWidth: 470,
            marginBottom: 20,
          }}
          textContainer={{
            margin: 0,
            padding: 10,
          }}
          type="text"
          value={batchConfig?.description}
          onChangeText={(text) => {
            setBatchConfig({ ...batchConfig, description: text });
          }}
        />
        {(selectedTab?.routeId == "bm" || selectedTab?.routeId == "abm") && (
          <AppDropDown
            showTextInputLabel={false}
            label="Benchmark"
            inputLabelStyle={{
              marginLeft: 0,
              marginRight: 10,
              marginTop: 0,
            }}
            dropDownStyle={{
              borderColor: currentTheme?.theme?.border_color,
              maxWidth: 470,
            }}
            isElevated={false}
            dropdownIconColor="transparent"
            items={[
              { id: "none", name: "Select benchmark" },
              ...state?.benchmarks,
            ]}
            propertyLabel="name"
            propertyValue="id"
            selectedValue={batchConfig?.benchmarkID}
            onValueChange={(itemValue, itemIndex) => {
              setBatchConfig({
                ...batchConfig,
                benchmarkID: itemValue,
              });
            }}
          />
        )}
        {(selectedTab?.routeId === "bm" || selectedTab?.routeId === "abm") && (
          <>
            <AppDropDown
              withEmptyItem
              isElevated={false}
              dropDownStyle={{
                borderColor: currentTheme?.theme?.border_color,
                maxWidth: 465,
              }}
              wrapperContainer={{
                marginBottom: 20,
                marginTop: 20,
              }}
              items={[
                {
                  type: "noSelection",
                  label: "Select a reviewing model",
                },
                ..._reviewModels?.map((model) => ({
                  label: model?.name,
                  id: model?.id,
                })),
              ]}
              propertyLabel="label"
              propertyValue="id"
              onValueChange={(value) => {
                console.log("value", value);
                setBatchConfig({
                  ...batchConfig,
                  reviewerAgentID: value,
                });
              }}
            />
            <AppText
              style={{
                fontWeight: "bold",
                fontSize: 16,
                marginVertical: 10,
                marginLeft: 10,
              }}
            >
              Evaluation criteria
            </AppText>
            <AppWeightDistribution
              containerStyle={{
                paddingLeft: 10,
                paddingVertical: 10,
                paddingRight: 0,
              }}
              onWeightsChange={handleWeightsChange}
              initialWeights={batchConfig?.weights}
            />
            <ToothFairySlider
              wrapperStyleSecureTextInput={{
                marginLeft: 10,
                marginRight: 0,
              }}
              step={0.1}
              maximumValue={100}
              minimumValue={50}
              unitLabel={"%"}
              label="Passing Threshold score (%)"
              onSubmit={(v) => {
                setBatchConfig({
                  ...batchConfig,
                  passingThreashold: v,
                });
              }}
              initialValue={batchConfig?.passingThreashold || 90}
            />
          </>
        )}
      </>
    );
  }, [
    batchConfig?.name,
    batchConfig?.description,
    setBatchConfig,
    JSON.stringify(batchConfig),
    JSON.stringify(state?.agents),
    selectedTab?.routeId,
    state?.benchmarks?.length,
  ]);

  return (
    <AppChoice
      wrapperStyle={{ alignSelf: "center", maxWidth: 600 }}
      caption={``}
      subCaption="The process will generate a csv file that will be available for download"
      cancelCaption="Click 'Cancel' to abort"
      confirmCaption="Click 'Confirm' to start the run"
      onConfirmButtonPress={() => {
        if (
          (batchConfig?.agentId == null ||
            batchConfig?.agentId === "noSelection" ||
            batchConfig?.agentId == "[object Object]") &&
          (selectedTab?.routeId === "bm" || selectedTab?.routeId === "abm")
        ) {
          AppToasty.show("Please select an agent", {
            placement: "bottom",
            type: "danger",
          });
          return;
        }
        if (selectedTab?.routeId === "abm" || selectedTab?.routeId === "bm") {
          if (!batchConfig.name || batchConfig?.name?.length === 0) {
            return AppToasty.show("Please enter a name for the benchmark run", {
              type: "danger",
            });
          }
          if (!batchConfig.agentId) {
            return AppToasty.show(
              "Please select an agent for the benchmark run",
              {
                type: "danger",
              }
            );
          }
          if (!batchConfig.reviewerAgentID) {
            return AppToasty.show(
              "Please select a reviewer model for the benchmark run",
              {
                type: "danger",
              }
            );
          }
          if (batchConfig.benchmarkID == "none" || !batchConfig.benchmarkID) {
            return AppToasty.show(
              "Please select a benchmark for the benchmark run",
              {
                type: "danger",
              }
            );
          }
          handleBatchInitiation(batchConfig);
          setIsBatchInitiationModalOpen(false);
        } else {
          AppToasty.show(t("batchParsingCreationFailedCaption"), {
            placement: "bottom",
            type: "danger",
          });
        }
      }}
      onCancelButtonPress={() => {
        setIsBatchInitiationModalOpen(false);
      }}
      AppChoiceButton={ToothFairyButton}
    >
      <View
        style={{
          flexDirection: "column",
          marginTop: 20,
        }}
      >
        {_inputFields}
      </View>
    </AppChoice>
  );
};

export default MetaSelection;
